export enum ImageMode {
  crop = 'CROP',
  pad = 'PAD',
  downscale = 'DOWNSCALE'
}
